const productcard = document.querySelectorAll(".product-card__product");
const activeType = document.querySelector(".filter__list-item .active");

function colorSwatchs() {
  productcard.forEach((card) => {
    const productImages = card.querySelectorAll(".product-card__image img");
    const productSwatchs = card.querySelectorAll(".product-card__color");
    const productSelect = card.querySelector(".product-card__select");
    const productFormAddToCart = card.querySelector(".product-card__addcart");
    const productPrice = card.querySelector(".product-card__price");

    productSwatchs.forEach((swatch) => {
      if (swatch.classList.contains("active")) {
        activateImage(swatch, productImages);
        activateImageHover(card);
      }
      swatch.addEventListener("click", () => {
        let activeSize = card.querySelector(".product-card__size.active");
        const firstSize = card.querySelectorAll(".product-card__size")[0];

        if (activeSize) {
          activeSize = activeSize.dataset.option;
        } else {
          activeSize = firstSize.dataset.option;
        }

        removeActive(productSwatchs);
        swatch.classList.add("active");
        activateImage(swatch, productImages);
        activateImageHover(card);
        Array.from(productSelect).forEach((option) => {
          const optionColor = option.dataset.title.split(" / ")[1];
          const optionSize = option.dataset.title.split(" / ")[0];
          if (
            optionColor === swatch.dataset.option &&
            optionSize === activeSize
          ) {
            if (option.dataset.available == "false") {
              productFormAddToCart.innerHTML = "Sold Out";
              productFormAddToCart.disabled = true;
            } else {
              productFormAddToCart.innerHTML = "Add to Cart";
              productFormAddToCart.disabled = false;
            }
            option.selected = true;

            if (
              typeof option.dataset.comparePrice != "undefined" &&
              option.dataset.comparePrice != ""
            ) {
              checkComparePrice(
                option.dataset.price,
                option.dataset.comparePrice,
                productPrice
              );
            } else {
              checkComparePrice(option.dataset.price, "", productPrice);
            }
          }
        });
      });
    });
  });
}

function checkComparePrice(price, comparePrice, productPrice) {
  if (comparePrice != "" && price != "") {
    productPrice.innerHTML =
      price + " " + comparePrice.replace("money", "compare-price");
  } else if (price != "") {
    productPrice.innerHTML = price;
  }
}

function activateImage(swatch, productImages) {
  removeActive(productImages);
  productImages.forEach((image) => {
    let imgAlt = image.alt;
    if (imgAlt.includes(" &")) {
      imgAlt = image.alt.split(" &")[0];
    }
    let imageAltColor = imgAlt.split(" /")[0];
    let imageAltType = imgAlt.split(" / ")[1];

    if (activeType) {
      const activeTypeData = activeType.dataset.activeTag;
      if (
        imageAltColor == swatch.dataset.option &&
        activeTypeData == imageAltType
      ) {
        image.classList.add("active");
      }
    } else {
      if (imageAltColor == swatch.dataset.option) {
        image.classList.add("active");
      }
    }
  });
}

function activateImageHover(card) {
  const activeImages = card.querySelectorAll(".product-card__image img.active");
  const activeImagesFirst = activeImages[0];
  const activeImagesHover = activeImages[1];
  if (activeImagesFirst) {
    activeImagesFirst.classList.add("first_show");
  }
  if (activeImagesHover) {
    activeImagesHover.classList.add("hover_show");
  }
}

function changeSize() {
  productcard.forEach((card) => {
    const sizes = card.querySelectorAll(".product-card__size");
    const productForm = card.querySelector(".product-card__form");
    const productSelect = card.querySelector(".product-card__select");
    const productFormAddToCart = card.querySelector(".product-card__addcart");
    const productPrice = card.querySelector(".product-card__price");

    sizes.forEach((size) => {
      size.addEventListener("click", () => {
        let activeColor = card.querySelector(".product-card__color.active");
        if (activeColor) {
          activeColor = activeColor.dataset.option;
        }

        removeActive(sizes);
        size.classList.add("active");
        productForm.classList.add("active");
        Array.from(productSelect).forEach((option) => {
          if (option.dataset.title.includes(" / ")) {
            const optionSize = option.dataset.title.split(" / ")[0];
            const optionColor = option.dataset.title.split(" / ")[1];
            if (
              optionSize === size.dataset.option &&
              activeColor === optionColor
            ) {
              if (option.dataset.available == "false") {
                productFormAddToCart.innerHTML = "Sold Out";
                productFormAddToCart.disabled = true;
              } else {
                productFormAddToCart.innerHTML = "Add to Cart";
                productFormAddToCart.disabled = false;
              }
              option.selected = true;

              if (
                typeof option.dataset.comparePrice != "undefined" &&
                option.dataset.comparePrice != ""
              ) {
                checkComparePrice(
                  option.dataset.price,
                  option.dataset.comparePrice,
                  productPrice
                );
              } else {
                checkComparePrice(option.dataset.price, "", productPrice);
              }
            }
          } else if (!activeColor) {
            const optionTitle = option.dataset.title;
            if (optionTitle === size.dataset.option) {
              option.selected = true;
            }
          }
        });
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  colorSwatchs();
  changeSize();
});

function removeActive(array) {
  array.forEach((item) => {
    item.classList.remove("active");
  });
}
